import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { FullPageMainContent, OverlayPage } from 'root/components/IWLayout'
import IWButton from 'shared/components/thunderbolt/IWButton'
import IWPageHeader, {
  StyledTitle,
} from 'shared/components/thunderbolt/IWPageHeader'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import IWSpacer from 'shared/components/thunderbolt/IWSpacer'
import styled from 'styled-components'
import LSConvertWizard from '../components/LSConvertWizard'

const StyledCaretIcon = styled(FontAwesomeIcon)`
  align-self: center;
  font-size: 1rem;
  color: ${(props) => props.theme.palette.grey[400]};
`

const StyledWrapper = styled.div`
  margin: auto;
  max-width: ${(props) => props.theme.dimensions.maxScreenWidth};
  display: flex;
  flex: 1;
  gap: 0.5rem;
  justify-content: space-between;
`

const LoadSchedulingConvertPage = () => {
  const { t } = useTranslation()
  return (
    <OverlayPage>
      <IWPageHeader data-testid="page-header" isFullScreen>
        <StyledWrapper>
          <StyledTitle>{t('loadScheduling.loadScheduling')}</StyledTitle>
          <StyledCaretIcon icon={faChevronRight} />
          <StyledTitle>{t('loadScheduling.titles.demandBids')}</StyledTitle>
          <IWSpacer />
          <IWButton
            as="routerNavLink"
            to="/"
            variant="alternative"
            color="primary"
            data-testid="page-header-close-button"
          >
            {t('button.close')}
          </IWButton>
        </StyledWrapper>
      </IWPageHeader>

      <FullPageMainContent>
        <LSConvertWizard />
      </FullPageMainContent>
    </OverlayPage>
  )
}

export default LoadSchedulingConvertPage
